/**
 * Enhanced Sticky Add to Cart Button
 * Features: Zepto/Flipkart style with price, cart icon, responsive design, scroll-based visibility
 */

(function() {
  'use strict';

  let stickyCart = null;
  let isVisible = false;
  let productData = null;

  function init() {
    // Get product data
    const productForm = document.querySelector('.product-form, form[action*="cart/add"]');
    if (!productForm) return;

    productData = extractProductData();
    if (!productData) return;

    createStickyCart();
    setupEventListeners();
    handleScroll();
  }

  function extractProductData() {
    const productNameEl = document.querySelector('.product-name h1, .product-title, h1');
    const priceEl = document.querySelector('.price-box .price, #price .price, .detail-price .price');
    const addToCartBtn = document.querySelector('.add-to-cart, .btn-cart, button[name="add"]');
    
    if (!productNameEl || !priceEl || !addToCartBtn) return null;

    return {
      name: productNameEl.textContent.trim(),
      price: priceEl.textContent.trim(),
      available: !addToCartBtn.disabled && !addToCartBtn.classList.contains('disabled'),
      buttonText: addToCartBtn.querySelector('span')?.textContent.trim() || addToCartBtn.textContent.trim() || 'Add to Cart'
    };
  }

  function createStickyCart() {
    stickyCart = document.createElement('div');
    stickyCart.className = 'sticky-cart-enhanced';
    stickyCart.innerHTML = `
      <div class="sticky-cart-container">
        <div class="sticky-cart-content">
          <div class="sticky-cart-info">
            <div class="sticky-cart-price">${productData.price}</div>
            <div class="sticky-cart-name">${productData.name}</div>
          </div>
          <button class="sticky-cart-btn ${!productData.available ? 'disabled' : ''}" 
                  ${!productData.available ? 'disabled' : ''}>
            <i class="icon-cart"></i>
            <span>${productData.buttonText}</span>
          </button>
        </div>
      </div>
    `;

    // Add CSS styles
    addStyles();
    
    document.body.appendChild(stickyCart);
  }

  function addStyles() {
    if (document.getElementById('sticky-cart-enhanced-styles')) return;

    const styles = document.createElement('style');
    styles.id = 'sticky-cart-enhanced-styles';
    styles.textContent = `
      .sticky-cart-enhanced {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        background: #fff;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        transform: translateY(100%);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border-top: 1px solid #e7e7e7;
        opacity: 0;
        visibility: hidden;
      }

      .sticky-cart-enhanced.visible {
        transform: translateY(0);
        opacity: 1;
        visibility: visible;
      }

      .sticky-cart-container {
        max-width: 600px;
        margin: 0 auto;
        padding: 0 15px;
      }

      .sticky-cart-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        gap: 15px;
      }

      .sticky-cart-info {
        flex: 1;
        min-width: 0;
      }

      .sticky-cart-price {
        font-size: 18px;
        font-weight: 700;
        color: #222529;
        line-height: 1.2;
        margin-bottom: 2px;
      }

      .sticky-cart-name {
        font-size: 13px;
        color: #666;
        line-height: 1.3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .sticky-cart-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        background: var(--theme-color, #222529);
        color: #fff;
        border: none;
        padding: 12px 24px;
        border-radius: 6px;
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 140px;
        justify-content: center;
        font-family: inherit;
      }

      .sticky-cart-btn:hover:not(.disabled) {
        background: var(--theme-color-dark, #333);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(34, 37, 41, 0.3);
      }

      .sticky-cart-btn.disabled {
        background: #ccc;
        cursor: not-allowed;
        opacity: 0.6;
      }

      .sticky-cart-btn.loading {
        opacity: 0.8;
        pointer-events: none;
      }

      .sticky-cart-btn.loading i {
        animation: spin 1s linear infinite;
      }

      .sticky-cart-btn i {
        font-size: 16px;
      }

      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      /* Mobile styles */
      @media (max-width: 767px) {
        .sticky-cart-enhanced {
          left: 15px;
          right: 15px;
          bottom: 80px;
          border-radius: 25px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
          max-width: 200px;
          margin: 0 auto;
        }

        .sticky-cart-container {
          padding: 0;
        }

        .sticky-cart-content {
          padding: 0;
        }

        .sticky-cart-info {
          display: none;
        }

        .sticky-cart-btn {
          width: 100%;
          padding: 10px 16px;
          font-size: 11px;
          font-weight: 600;
          gap: 4px;
          border-radius: 25px;
        }

        .sticky-cart-btn i {
          font-size: 12px;
        }

        /* Hide original add to cart on mobile */
        .product-options-bottom {
          display: none !important;
        }
      }

      /* Desktop styles */
      @media (min-width: 768px) {
        .sticky-cart-enhanced {
          left: 50%;
          right: auto;
          transform: translateX(-50%) translateY(100%);
          border-radius: 12px 12px 0 0;
          max-width: 600px;
          margin-bottom: 20px;
          box-shadow: 0 -4px 25px rgba(0, 0, 0, 0.15);
        }

        .sticky-cart-enhanced.visible {
          transform: translateX(-50%) translateY(0);
        }

        .sticky-cart-container {
          padding: 0 24px;
        }

        .sticky-cart-content {
          padding: 18px 0;
        }

        .sticky-cart-btn {
          padding: 14px 28px;
          font-size: 15px;
        }
      }

      /* Animation for price updates */
      .sticky-cart-price {
        transition: color 0.2s ease;
      }

      .sticky-cart-price.updating {
        color: #007bff;
      }
    `;

    document.head.appendChild(styles);
  }

  function setupEventListeners() {
    // Handle sticky cart button click
    stickyCart.querySelector('.sticky-cart-btn').addEventListener('click', function() {
      if (this.disabled) return;
      
      const form = document.querySelector('form[action*="/cart/add"], .product-form');
      if (form) {
        // Add loading state
        this.classList.add('loading');
        this.querySelector('span').textContent = 'Adding...';
        
        // Submit the form directly
        const formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Success - trigger cart update
          if (window.theme && window.theme.cartUpdateCallback) {
            window.theme.cartUpdateCallback();
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
        })
        .catch(() => {
          // Fallback to button click
          const btn = form.querySelector('button[type="submit"], .add-to-cart');
          if (btn) btn.click();
        })
        .finally(() => {
          setTimeout(() => {
            this.classList.remove('loading');
            this.querySelector('span').textContent = productData.buttonText;
          }, 1000);
        });
      }
    });

    // Handle scroll events
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check
    setTimeout(handleScroll, 100);

    // Handle variant changes
    const variantSelectors = document.querySelectorAll('.single-option-selector, input[name^="option"], .swatch input');
    variantSelectors.forEach(selector => {
      selector.addEventListener('change', updateProductInfo);
    });

    // Listen for Shopify variant changes
    if (window.Shopify && window.Shopify.OptionSelectors) {
      const originalCallback = window.selectCallback;
      window.selectCallback = function(variant, selector) {
        if (originalCallback) {
          originalCallback.call(this, variant, selector);
        }
        updateProductInfo();
      };
    }

    // Handle window resize
    window.addEventListener('resize', debounce(handleScroll, 100));
  }

  function handleScroll() {
    const isMobile = window.innerWidth <= 767;
    const addToCartBtn = document.querySelector('.add-to-cart, .btn-cart, button[type="submit"]');
    const footer = document.querySelector('footer, .footer, .main-footer');
    
    if (!addToCartBtn) return;

    const btnRect = addToCartBtn.getBoundingClientRect();
    const footerRect = footer ? footer.getBoundingClientRect() : null;

    let shouldShow;
    if (isMobile) {
      shouldShow = true;
    } else {
      // Desktop: show when button is scrolled past viewport
      shouldShow = btnRect.top < -50;
    }
    
    const shouldHide = footerRect && footerRect.top < window.innerHeight;
    const newVisibility = shouldShow && !shouldHide;

    if (newVisibility !== isVisible) {
      isVisible = newVisibility;
      stickyCart.classList.toggle('visible', isVisible);
    }
  }

  function updateProductInfo() {
    if (!stickyCart) return;
    
    // Wait for variant change to complete
    setTimeout(() => {
      const newProductData = extractProductData();
      if (!newProductData) return;

      const priceEl = stickyCart.querySelector('.sticky-cart-price');
      const btnEl = stickyCart.querySelector('.sticky-cart-btn');
      const btnSpan = btnEl.querySelector('span');

      // Animate price change
      if (newProductData.price !== productData.price) {
        priceEl.classList.add('updating');
        setTimeout(() => {
          priceEl.textContent = newProductData.price;
          priceEl.classList.remove('updating');
        }, 150);
      }

      // Update button state
      btnEl.disabled = !newProductData.available;
      btnEl.classList.toggle('disabled', !newProductData.available);
      btnSpan.textContent = newProductData.buttonText;

      productData = newProductData;
    }, 200);
  }

  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 200);
  }

  // Expose for manual initialization if needed
  window.StickyCartEnhanced = { init };
})();